var _circle, _path, _circle2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVacancyLimitModalIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 55,
    r: 23.75,
    fill: "#FFEAE9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.625 24.1596V5.625L14.375 5.625V71.875H65.625V54.6509",
    stroke: "black",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.9453,
    cy: 39.375,
    r: 17.375,
    stroke: "#E53B34",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1558 30.1003C54.7515 30.3082 54.6706 30.6607 54.7818 31.646C54.8323 32.1612 55.0143 33.8154 55.1861 35.334C55.3478 36.8526 55.5399 38.561 55.6005 39.1305C55.7723 40.8751 55.934 41.1191 56.8538 41.1191C57.531 41.1191 57.8645 40.8028 57.9555 40.0706C57.9858 39.7813 58.1778 38.1723 58.3699 36.5091C58.572 34.8459 58.7944 32.9386 58.8752 32.2697C59.0774 30.6246 59.0774 30.5794 58.7337 30.263C58.5778 30.0967 58.3476 30.0007 58.1049 30.0007L56.8841 30.0009C56.025 30.0009 55.2569 30.0461 55.1558 30.1003Z",
    fill: "#E53B34"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1862 43.3488C55.577 43.5692 55.2175 43.9197 54.8979 44.6009C54.3985 45.6726 55.1076 47.0649 56.3261 47.4155C57.6843 47.8062 59.0126 46.7945 59.0126 45.3621C59.0126 43.8697 57.5745 42.858 56.1862 43.3488Z",
    fill: "#E53B34"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 16.25H48.75",
    stroke: "#222829",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 62.5H48.75",
    stroke: "#222829",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 22.5H40",
    stroke: "#222829",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 55H40",
    stroke: "#222829",
    strokeWidth: 1.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 28.75H35",
    stroke: "#222829",
    strokeWidth: 1.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 47.5H35",
    stroke: "#222829",
    strokeWidth: 1.5
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 35H30",
    stroke: "#222829",
    strokeWidth: 1.5
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 41.25H30",
    stroke: "#222829",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVacancyLimitModalIcon);
export default __webpack_public_path__ + "static/media/vacancy-limit-modal-icon.25eba53fa23f254bf4af924f3ec2f468.svg";
export { ForwardRef as ReactComponent };